import React, { useEffect } from 'react'

import NoticeList from '@components/pages/important-notices/NoticeList'
import notices from '@utils/notices'
import { DiscreteEvent, dispatchCustomEvent, KPI } from '@utils/customEvents'
import { Enrollment } from '@clear-denver/tpc-openapi-typescript'
import { getXCLEARCorrelationInfo } from '@clear-denver/tpc-openapi-typescript/build/utils'
import router from 'next/router'

function ImportantNotices() {
  useEffect(() => {
    const xCLEARCorrelationInfo = getXCLEARCorrelationInfo()
    dispatchCustomEvent(Enrollment.LogEntryLevelEnum.INFO, {
      payload: {
        message: 'Important Notices View',
      },
      metadata: {
        kpi: KPI.USER_INTERACTION,
        xCLEARCorrelationInfo,
        url: router.asPath,
        event: DiscreteEvent.NOTICES_VIEW,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <div className="flex-grow max-w-4xl px-4 py-10 m-auto">
        <div className="mb-10 text-center" data-cy="important-notice-logo">
          <h1 className="text-4xl font-bold">Important Notices</h1>
        </div>
        <NoticeList notices={notices} />
      </div>
    </>
  )
}

export default ImportantNotices
